// CORE
import React from 'react';

// Store
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';

// UI
import { View } from '@upstox/upstox-ui';
import VisibleToast from './components/VisibleToast';

// Styles
import * as css from './styles';

const ToastContainer: React.FC = () => {
  const { toastNotifications, deleteToast } = useStore('NotificationStore');
  const toastNotificationsArray = Array.from(toastNotifications);

  const doesFirstToastExist = !!toastNotificationsArray.length;
  const firstToastKey = doesFirstToastExist && toastNotificationsArray[0][0];
  const firstToastValue = doesFirstToastExist && toastNotificationsArray[0][1];

  return (
    <View css={css.toastContainer} flexDirection="column" gap="medium">
      {Boolean(firstToastKey && firstToastValue) && (
        <VisibleToast
          // We need 'key' attribute in order React understand that we do need need to update Visible toast
          // if key has changed - we need to create new element
          key={firstToastKey as string}
          id={firstToastKey as string}
          toast={firstToastValue as ToastOptions}
          deleteToast={deleteToast}
        />
      )}
    </View>
  );
};

export default observer(ToastContainer);
